import getAccessToken from './methods/getAccessToken'
import getAuthData from './methods/getAuthData'
import isAuthenticated from './methods//isAuthenticated'
import signin from './methods/signin'
import signout from './methods/signout'
import type {
  AuthConfig,
  AuthClient,
  GetAuthDataOptions,
  IsAuthenticatedOptions,
  Provider,
  SignInOptions,
  SignOutOptions,
} from './types/types'
import type { Tokens } from './types/tokenTypes'
import setTokens from './methods/setTokens'
import getUserData from './methods/getUserData'
import setCurrentContact from './methods/setCurrentContact'
import getContacts from './methods/getContacts'
import getTokensForContact from './methods/getTokensForContact'
import getZendeskToken from './methods/getZendeskToken'

export { default as cookieHandler, names as cookieNames } from './handlers/cookieHandler'
export type {
  AccessTokenContactData,
  AccessTokenData,
  AccessTokenIdentityProviderData,
  IdTokenData,
  TokenData,
  Tokens,
  ValidTokens,
} from './types/tokenTypes'
export type {
  AuthConfig,
  AuthData,
  Contact,
  AuthClient,
  GetAuthDataOptions,
  GetTokensForContactResult,
  IdentityProvider,
  IdentityProviderName,
  IsAuthenticatedOptions,
  IssuerProvider,
  Profile,
  Provider,
  SignInOptions,
  SignOutOptions,
  SiteType,
  SourcingCompany,
  UserData,
} from './types/types'

export const dustinAuth = (config: AuthConfig, cookieHeader?: string): AuthClient => {
  return {
    isAuthenticated: (options?: IsAuthenticatedOptions) =>
      isAuthenticated(config, cookieHeader)(options),
    signIn: (options?: SignInOptions) => signin(config, cookieHeader)(options),
    signOut: (options?: SignOutOptions) => signout(config)(options),
    getAccessToken: () => getAccessToken(config, cookieHeader)(),
    getZendeskToken: () => getZendeskToken(config, cookieHeader)(),
    setTokens: (tokens: Tokens, provider: Provider) => setTokens(cookieHeader)(tokens, provider),
    getAuthData: (code: string, options?: GetAuthDataOptions, contactId?: number) =>
      getAuthData(config, cookieHeader)(code, options, contactId),
    getUserData: () => getUserData(config, cookieHeader)(),
    setCurrentContact: (contactId: number) => setCurrentContact(config, cookieHeader)(contactId),
    getContacts: () => getContacts(config, cookieHeader)(),
    getTokensForContact: (contactId: number) =>
      getTokensForContact(config, cookieHeader)(contactId),
  }
}
